<template>
  <lb-dialog
    v-model="internalValue"
    :heading="heading"
    :width="width"
    :loading="loading"
  >
    <template v-slot:body>
      <div class="mb-4">
        <v-btn color="primary" class="mb-3" @click="$emit('download-template')"><span>Download Template</span></v-btn>
        
        <lb-file
          v-model="fileModel"
          :label="hasData ? 'Re-Upload' : 'Browse Files'"
          :drag="false"
          hidedetails
          @change="onFileChange"
          :displayname="true"
          accept=".xlsx,.xls,.xlsm,.xlsb"
          :dropzone="true"
          dropzone-text="Drag and drop your Excel file here"
          dropzone-hint="Supported formats: .xlsx, .xls, .xlsm, .xlsb"
          :remove="true"
        />
      </div>
      <div v-if="hasData">
        <lb-datatablenew
          :headers="headers"
          :items="normalizedItems"
          :enableslot="enableslot"
          :loading="loading"
          :perpage="10"
        >
          <template v-slot:ignore="{ item }">
            <div style="width:30px;">
              <v-icon v-if="item.error || !item.__found" color="error">mdi-close-circle</v-icon>
              <v-icon v-else-if="!item.ignore" color="success">mdi-check-circle</v-icon>
            </div>
          </template>
          <template v-slot:message="{ item }">
            <div :class="{ 'error--text': item.error || item.ignore }">
              <span v-if="!item.__found">{{ glCodeLabel }} not found</span>
              <span v-else>{{ item.message || item.error }}</span>
            </div>
          </template>
        </lb-datatablenew>
      </div>
    </template>
    <template v-slot:actions>
      <div v-if="hasError" class="error--text font-weight-semibold">
        Mandatory regional comments are missing for one or more GLs. Please rectify the same to proceed with the upload.
      </div>
      <div v-else-if="hasData" class="info--text">
        Note: Only the GL's which are in {{ localCommentaryAwaitedLabel }} will be updated with this bulk upload option.
      </div>
      <v-spacer />
      <v-btn
        v-if="hasData && !hasError"
        @click="$emit('submit')"
        color="primary"
        class="ml-2"
        :disabled="disableSubmit"
      ><span>Proceed to Upload</span></v-btn>
    </template>
  </lb-dialog>
</template>

<script>
export default {
  name: 'BulkUploadCommentaryApproverDialog',
  props: {
    value: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    width: { type: [Number, String], default: '' },
    fileValue: { type: [File, null], default: null },
    headers: { type: Array, default: () => [] },
    items: { type: Array, default: () => [] },
    enableslot: { type: Array, default: () => ['message', 'ignore'] },
    hasError: { type: Boolean, default: false },
    disableSubmit: { type: Boolean, default: false },
    glCodeLabel: { type: String, default: '' },
    localCommentaryAwaitedLabel: { type: String, default: '' },
    heading: { type: String, default: 'Bulk Upload Commentary Approver' },
  },

  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    hasData() {
      return this.normalizedItems.length > 0;
    },
    fileModel: {
      get() {
        return this.fileValue;
      },
      set(value) {
        this.$emit('update:file-value', value);
      },
    },
    normalizedItems() {
      if (Array.isArray(this.items)) {
        return this.items;
      }
      if (this.items && typeof this.items === 'object') {
        return Object.keys(this.items).map(key => ({
          __key: key,
          ...(this.items[key] || {}),
        }));
      }
      return [];
    },
  },
  methods: {
    onFileChange(event) {
      const file = event?.target?.files?.[0] || event || null;
      this.$emit('update:file-value', file);
      this.$emit('file-change', event);
    },
  },
};
</script>
